export default __webpack_public_path__ + "static/media/img_major02_1.829e3763.jpg";